import {
  LoanType,
  EntityTypes,
  DurationType,
  DefaultProjectionYear,
  RepaymentTypeOptionValue,
} from "../helpers/constant";
import { CommonHelper } from "../helpers";

export default {
  setLoanInformation(payload, clientInfo) {
    return payload.map((r) => {
      let p = {};
      let loanOwnerName = clientInfo.filter((item) => {
        return item.clientId == r.ownerId;
      });
      p.clientName =
        loanOwnerName && loanOwnerName.length > 0
          ? loanOwnerName[0].clientName
          : "";
      p.clientId = r.clientId;
      p.clientProportion = r.clientProportion;
      p.entityType =
        loanOwnerName && loanOwnerName.length > 0
          ? loanOwnerName[0].entityType
          : "";

      p.creditLimit = r.creditLimit;
      p.projectionYear =
        r.projectionYear == 0 || !r.projectionYear
          ? DefaultProjectionYear
          : r.projectionYear;
      p.description = r.description;
      p.lastModifiedDateTime = r.lastModifiedDateTime;
      p.interestRatePI = r.interestRatePI;
      p.loanTypeName =
        r.loanTypeId == LoanType.Home
          ? "Home Loan"
          : r.loanTypeId == LoanType.Personal
          ? "Personal loan"
          : "Others";
      p.loanTypeId =
        r.loanTypeId != LoanType.Home && r.loanTypeId != LoanType.Personal
          ? LoanType.Other
          : r.loanTypeId;
      p.liabilityTypeId =
        r.liabilityTypeId == 0
          ? RepaymentTypeOptionValue.Minimum_Repayment
          : r.liabilityTypeId;
      p.liabilityId = r.liabilityId;
      p.outstandingAmount = r.outstandingAmount;
      p.ownerEntityId = r.ownerEntityId;
      p.partnerProportion = r.partnerProportion;
      p.termPI = r.termPI;
      p.interestRate = r.interestRate;
      p.isExisting = r.isExisting;
      p.taxDeductibility = r.taxDeductibility;
      p.repaymentTypeId = r.repaymentTypeId;
      p.ownerId = r.ownerId;
      p.repaymentAmount = r.repaymentAmount;
      p.term = r.term > 100 ? 100 : r.term;
      p.months = r.months;
      p.loanAmount = r.loanAmount;
      p.liabilityGuid = r.liabilityGuid;
      p.maturityDate = r.maturityDate;
      p.offsetAgePension = r.offsetAgePension;
      p.offsetDescription = r.offsetDescription;
      p.offsetInterestRate = r.offsetInterestRate;
      p.offsetStartDate = r.offsetStartDate;
      p.investmentAmount = r.investmentAmount;
      p.investmentId = r.investmentId;
      p.isDeductible = r.isDeductible;
      p.startDate = r.startDate;
      p.startDateTypeId = r.startDateTypeId;
      p.durationType = r.durationType;
      p.durationTypeId =
        r.durationTypeId == DurationType.Half_Year ||
        r.durationTypeId == DurationType.Years
          ? DurationType.Weeks
          : r.durationTypeId;
      p.isFromFact = r.isFromFact;
      p.userdurationType =
        r.durationTypeId == DurationType.Weeks
          ? "Weekly"
          : r.durationTypeId == DurationType.Months
          ? "Monthly"
          : r.durationTypeId == DurationType.Fortnights
          ? "Fortnightly"
          : DurationType.Weeks;

      p.factOutstandingBalance = r.factOutstandingBalance;
      p.isFactDataChanges =
        p.isFromFact && p.factOutstandingBalance != p.outstandingAmount
          ? true
          : false;
      p.advancedetails = !r.advancedetails ? [] : r.advancedetails;
      p.s3FilePath = r.s3FilePath;
      return p;
    });
  },

  getEmptyLoanModel(clientInfo) {
    let p = {};
    p.clientName = clientInfo.clientName;
    p.clientId = clientInfo.clientId;
    p.clientProportion = 0;
    p.entityType = 1;
    p.creditLimit = 0;
    p.projectionYear = DefaultProjectionYear;
    p.description = "New Loan";
    p.interestRatePI = 0;
    p.loanTypeName = "Home Loan";
    p.loanTypeId = LoanType.Home;
    p.liabilityTypeId = RepaymentTypeOptionValue.Minimum_Repayment;
    p.liabilityId = 0;
    p.outstandingAmount = 0;
    p.ownerEntityId = 1;
    p.partnerProportion = 0;
    p.termPI = 0;
    p.interestRate = 0;
    p.isExisting = false;
    p.taxDeductibility = 0;
    p.repaymentTypeId = 0;
    p.ownerId = clientInfo.clientId;
    p.repaymentAmount = 0;
    p.term = 0;
    p.months = 0;
    p.loanAmount = 0;
    p.liabilityGuid = "00000000-0000-0000-0000-000000000000";
    p.maturityDate = null;
    p.offsetAgePension = false;
    p.offsetDescription = "";
    p.offsetInterestRate = 0;
    p.offsetStartDate = null;
    p.investmentAmount = 0;
    p.investmentId = 0;
    p.isDeductible = false;
    p.startDate = new Date().toISOString().slice(0, 10);
    p.startDateTypeId = 0;
    p.durationType = null;
    p.durationTypeId = DurationType.Weeks;
    p.isFromFact = false;
    p.userdurationType = DurationType.Weeks;
    p.date = null;
    p.text = "";
    p.profileName = "";
    p.amount = 0;
    p.tagName = "";
    p.name = "Amount";
    p.entityName = "";
    p.factOutstandingBalance = 0;
    p.isFactDataChanges = false;
    p.advancedetails = [];
    p.s3FilePath = "";
    return p;
  },

  setLoanEntiyInformation(clientInfo) {
    let entityInfo = clientInfo.map((r) => {
      if (!(r.entityType == EntityTypes.Super && r.superFundTypeId == 1)) {
        let p = {};
        p.value = r.clientId;
        p.text = r.clientName.replace(/(^MRS|MR|MISS)/gi, "");
        p.dob = CommonHelper.formatDate(r.dob, false, "/");
        p.gender = r.gender;
        p.entityType = r.entityType;
        p.id = r.entityType == EntityTypes.both ? 2.1 : r.entityType;
        return p;
      }
    });
    let selectedUser = entityInfo.filter((sr) => sr != undefined);
    if (selectedUser && selectedUser.length > 0) {
      selectedUser = selectedUser.sort(function (a, b) {
        return a.id - b.id;
      });
    }
    return selectedUser;
  },
  setLoanTypeInformation() {
    let loanType = [];
    loanType.push({ value: LoanType.Home, text: "Home Loan" });
    loanType.push({ value: LoanType.Personal, text: "Personal loan" });
    loanType.push({ value: LoanType.Other, text: "Others" });
    return loanType;
  },

  // Foramtting Date
  CreateSaveLoanModel(formModel, currentLoanInfo) {
    let totalElement = formModel.elements.length;
    let htmlName = "";
    for (let i = 0; i < totalElement; i++) {
      htmlName = formModel.elements[i].htmlName;
      if (htmlName == "initialbalance") {
        currentLoanInfo.outstandingAmount = formModel.elements[i].value;
      } else if (htmlName == "interestRate") {
        currentLoanInfo.interestRate = formModel.elements[i].value;
      } else if (htmlName == "repaymentType") {
        currentLoanInfo.liabilityTypeId = formModel.elements[i].value;
      } else if (htmlName == "loanterm") {
        currentLoanInfo.term = formModel.elements[i].value;
      } else if (htmlName == "repaymentAmount") {
        currentLoanInfo.repaymentAmount = formModel.elements[i].value;
      } else if (htmlName == "repaymentFrequency") {
        currentLoanInfo.durationTypeId = formModel.elements[i].value;
        currentLoanInfo.durationType =
          currentLoanInfo.durationTypeId == DurationType.Weeks
            ? "Weeks"
            : currentLoanInfo.durationTypeId == DurationType.Months
            ? "Months"
            : currentLoanInfo.durationTypeId == DurationType.Fortnights
            ? "Fortnights"
            : currentLoanInfo.durationTypeId == DurationType.Half_Year
            ? "Half Year"
            : currentLoanInfo.durationTypeId == DurationType.Years
            ? "Years"
            : "";
      }

      currentLoanInfo.ErrorText = [];
      currentLoanInfo.IsError = false;
    }
    return currentLoanInfo;
  },
};
